<!-- 非营业部盖章申请 -->
<template>
	<div class="pages">
		<div v-for='(item,index) in templateData.TemplateContent.Controls' :key='index'>
			<Digit v-if='item.Property.Control=="Number"' :data-val='item'></Digit>
			<Contact v-if='item.Property.Control=="Condition"' :data-val="item"></Contact>
			<Dates v-if='item.Property.Control=="Date"' :data-val="item"></Dates>
			<Version v-if='item.Property.Control=="Text"' @child-event='getTextVal' :data-val="item"></Version>
			<Money v-if='item.Property.Control=="Money"' :data-val="item"></Money>
			<Tips v-if='item.Property.Control=="Tips"' :data-val="item"></Tips>
			<File v-if='item.Property.Control=="File"' :data-val="item"></File>
			<Table v-if='item.Property.Control=="Table"' @child-event='tableOperation' :data-val='item'></Table>
			<Selector v-if='item.Property.Control=="Selector"' @child-event='getSelectorVal' :data-val='item'></Selector>
			<Textarea v-if='item.Property.Control=="Textarea"' :data-val='item'></Textarea>
			<Choose v-if='item.Property.Control=="Contact"' @child-event='clickChoose' :data-val='item'></Choose>
		</div>

		<Spin size="large" fix v-if="spinShow"></Spin>
		<Button class="submit-process" v-on:click='submit' v-bind:disabled="isDisabled"  v-bind:loading="formLoading" size="large" type="primary"> 提交 </Button>
	</div>
</template>

<script>
	/**
	 * Version 为Text文本组件
	 */
	import Digit from '../components/Number.vue'
	import Contact from '../components/Contact.vue';
	import Dates from '../components/Date.vue';
	import Version from '../components/Text.vue';
	import Money from '../components/Money.vue';
	import Tips from '../components/Tips.vue';
	import File from '../components/File.vue';
	import Table from '../components/Table.vue';
	import Selector from '../components/Selector.vue';
	import Textarea from '../components/Textarea.vue';
	
	import Choose from '../components/Choose.vue';
	import {
		initWxConfig
	} from '../api/jssdk.js';

	import stringUtils from "../assets/js/stringUtil.js";

    import { getTemplateInfo,submitProcess } from '@/api/approval'
	import {
		getRelation
	} from '@/api/employee'

	import {
			getDepartmentRelationByName,
			getDepartmentRelationById,
			getDepartmentInfo,
			getDepartmentRelationList
		} from '@/api/department'
	import {
		formatDate
	} from '@/utils/date'

	import wx from 'weixin-js-sdk'
	var isSubmit = false;

	var template = {
		TemplateContent: {
			Controls: []
		}
	};

	export default {
		components: {
			Contact,
			Dates,
			Version,
			Money,
			Tips,
			File,
			Table,
			Digit,
			Selector,
			Textarea,
			Choose
		},
		data() {
			return {
				templateData: template,
				relationList: null,
				logInfo: null,
				templateId: "",
				spNo: null,
				listLoading: false,
				isDisabled: false,
				formLoading:false,
				spinShow: false,
				departFullNamep:""
			}
		},
		created() {
			initWxConfig(this);
			this.logInfo = this.getLoginUserInfo();
			this.templateId = this.$route.query.templateId;
			this.spNo = this.$route.query.spNo;
			this.getTemplate();
		},
		methods: {
			
			clickChoose: async function(dataVal, name) {
				var that = this;
				window.wx.invoke("selectEnterpriseContact", {
					"fromDepartmentId": 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
					"mode": "single", // 必填，选择模式，single表示单选，multi表示多选
					"type": ["department"], // 必填，选择限制类型，指定department、user中的一个或者多个
					"selectedDepartmentIds": [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
					"selectedUserIds": [] // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
				}, async function(res) {
					
					if (res.err_msg == "selectEnterpriseContact:ok") {
						if (typeof res.result == 'string') {
							res.result = JSON.parse(res.result) //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
						}
						var logFullName = that.logInfo.fullName
						var depart = res.result.departmentList[0]; // 已选的部门列表
						dataVal.Values.push([depart.id,depart.name]);
						dataVal.Value = depart.name;
						await getDepartmentInfo(depart.id).then(res => {
							let departFullName = res.Body.FullName;
							that.templateData.TemplateContent.Controls.forEach((item) => {
								if (item.Property.Title[0].Text == "流程条件") {
									if (departFullName.indexOf("原友信") === -1) {
										item.Value = 1;
									} else {
										item.Value = 2;
									}
								}
							})
							if(departFullName.indexOf("原友信") === -1){
								that.templateData.TemplateContent.Controls.forEach(async (item) => {
									if (item.Property.Title[0].Text == "逐级审批") {
										var zjspResults = []
										let queryFullName = res.Body.FullName;
										if(queryFullName.indexOf(logFullName) !== -1){
											queryFullName = logFullName
										}
										that.spinShow = true;
										if(departFullName.indexOf("综合事务部")>-1){
											await getRelation(that.logInfo.EmpNo).then(response => {
												response.Body[0].Nodes.forEach(findItems => {
													if(findItems.Items != null){
														zjspResults = zjspResults.concat(findItems.Items) 
													}
												})
											})
										}else{
											await getDepartmentRelationByName(queryFullName).then(data => {
												if (data.Body != null && data.Body.length > 0) {
													var nodeResults = that.Select(data.Body,e => e.Nodes)
													nodeResults.forEach(nodeResult => {
														nodeResult.forEach(findItems => {
															if(findItems.Items != null){
																zjspResults = zjspResults.concat(findItems.Items) 
															}
														})
													})
												}
											});
										}
										zjspResults = zjspResults.filter(e => e.JobLevel > 3 && e.JobLevel <= 8 && e.EmpNo != "SC12050030" && e.EmpNo != that.logInfo.EmpNo)
										that.spinShow = false;
										zjspResults.sort(function(a,b){
											return a.JobLevel - b.JobLevel
										})
										console.log('zjspResults',zjspResults);
										if (that.logInfo.fullName.indexOf(departFullName) != -1){
											zjspResults = zjspResults.filter(e => e.JobLevel > that.logInfo.JobLevel)
											item.Values = that.ConvertToComponent(zjspResults)
										}else{
											item.Values = that.ConvertToComponent(zjspResults)
										}
										console.log('item.Values1',item.Values);
										if (departFullName.indexOf("综合事务部") !== -1){
											let exits = false;
											for (var i = 0; i < item.Values.length; i++) {
												if(item.Values[i][0] == "SC02120002"){
													exits = true;
													break;
												}
											}
											if(!exits){
												item.Values.push(["SC02120002","卢华"])
											}
										}
										console.log('item.Values3',item.Values);
										if(!item.Values || item.Values.length<=0){
											item.Values = [];
											item.Values.push(that.$store.state.defaultMember);
										}
									}
									console.log('item.Values4',item.Values)
								})
							}
						});	
					}
				})
			},
			ConvertToComponent(datas){
				let results = []
				let keys = []
				datas.forEach(data => {
					let result = [data.EmpNo,data.EmpName]
					if (!keys.includes(data.EmpNo)){
						keys.push(data.EmpNo)
						results.push(result)
					}
				})
				return results;
			},
			Select(e,callback){
				var results = []
				for (var i = 0; i < e.length; i++) {
					var flag = callback(e[i])
					if (flag != null){
						results.push(flag)
					}
				}
				return results
			},
			SelectInc(e,callback){
				var results = []
				for (var i = 0; i < e.length; i++) {
					var flag = callback(e[i])
					if (flag != null){
						if(results.includes(flag)){
							results.push(flag)
						}
					}
				}
				return results
			},
			unique (arr) {
			  return Array.from(new Set(arr))
			},
			//方法
			getTemplate:async function() {
				this.listLoading = true;
				var departName=this.logInfo.fullName;
				if(departName.indexOf("非营业部") == -1
				  &&departName.indexOf("原友信")==-1
				  &&departName.indexOf("华西区")==-1
				  &&departName.indexOf("风险管理部")==-1
            && "SC12120055,SC23000279,SC18006436,SC10040097".indexOf(this.logInfo.EmpNo) == -1
        ){
					this.Message({ 
						message: '没有申请权限',
						type: 'error',
						duration: 1000
					});
					this.isDisabled=true;
				}
				getTemplateInfo(this.templateId).then(async response => {
					var controls = response.Body;
					var loginfo = this.logInfo;
					var that = this;
					controls.TemplateContent.Controls.forEach(async (item) => {
						
						
						if (item.Property.Title[0].Text == "流程编号") {
							item.IsShow = false;
						}
						if (item.Property.Title[0].Text == "逐级审批") {
							item.IsShow = false;
							item.Values = [];
							item.Values.push(that.$store.state.defaultMember);
						}
						if (item.Property.Title[0].Text == "是否为经理") {
							if(loginfo.PositionName.indexOf("主任")>-1||loginfo.PositionName.indexOf("经理")>-1){
								item.Config.Selector.Options.forEach(async(option) =>{
									if(option.Value[0].Text == "是"){
										item.Value =  option.Key;
									}
								})
							}else{
								item.Config.Selector.Options.forEach(async(option) =>{
									if(option.Value[0].Text == "否"){
										item.Value =  option.Key;
									}
								})
							}
							item.IsShow = false;
						}
					});
					this.templateData = this.assignControl(controls, this.logInfo);
					this.templateData = await this.assignControlBySpNo(controls, this.spNo);
					this.listLoading = false;
				});
			},
			getTextVal() {
			},
			getSelectorVal(val, name) {

				this.$forceUpdate()
			},
			tableOperation(val, type, datas) {
				if(type=='compute'){
					return;
				}
				this.tableoperation(val, type, datas, this);
			},
			submit() {
				//数据校验
				if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
					return;
				}
				if (isSubmit) {
					this.Message({
						message: '已提交',
						type: 'warning',
						duration: 1000
					});
					return;
				}
				var SummaryList = [];
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				
				var control1=this.templateData.TemplateContent.Controls.filter(t=>{return t.Property.Title[0].Text == "合同/资料名称"})[0]
				
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"内容： "+control1.Value,"Lang":"zh_CN"});
				SummaryList.push(info);
				
				var data = new Date();
				  var month =data.getMonth() < 9 ? "0" + (data.getMonth() + 1) : data.getMonth() + 1;
				  var date = data.getDate() <= 9 ? "0" + data.getDate() : data.getDate();
				  var dateTime = data.getFullYear() + "-" + month + "-" + date;
				var info={SummaryInfo:[]}
				info.SummaryInfo=[];
				info.SummaryInfo.push({"Text":"申请时间："+dateTime,"Lang":"zh_CN"});
				SummaryList.push(info);
				this.templateData.SummaryList=SummaryList;
				
				
				
				isSubmit = true;
				this.formLoading = true;
				//提交
				submitProcess(this.templateId, this.logInfo.EmpNo, this.spNo, this.templateData).then(response => {
					this.Message({
						message: '申请成功',
						type: 'success',
						duration: 3 * 1000
					});
					setTimeout(() => {
						this.$router.push("/index");
					}, 3000)
				}).finally(() => {
					isSubmit = false;
					this.formLoading = false;
				});
			}
		}
	}
</script>

<style scoped lang="less">
	.pages {
		padding-bottom: 14px;
	}
</style>
